import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate"

import user from './modules/user'

Vue.use(Vuex);



export default new Vuex.Store({
  modules:{
    user,
  },
  plugins: [createPersistedState({
    storage: window.localStorage,
    reducer(val) {
        return {
        // 只储存state中的user
        user:val.user,
      }
   }
})]
});


// WEBPACK FOOTER //
// ./src/store/index.js